import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  height: ${(props: { height?: string }) => props.height || '194px'};
  background-repeat: no-repeat;
  background: linear-gradient(211.13deg, #489edc 0%, #07416a 100%);
  background-size: auto 527px;
`;
export const StyledDiv = styled.div`
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
`;
